module.exports = __webpack_public_path__ + "img/s2.ddcc683d.png";